import { Tag as AntdTag, type TagProps as AntdTagProps } from 'antd';
import classNames from 'classnames';

interface TagProps extends AntdTagProps {
  text: React.ReactNode;
  textClassName?: string;
  type?: 'status' | 'transparent' | 'rounded';
}

export function Tag({
  text,
  type,
  className,
  textClassName,
  ...rest
}: Readonly<TagProps>) {
  return (
    <AntdTag
      className={classNames({ [`ant-tag-${type}`]: type }, className)}
      {...rest}
    >
      <span className={classNames(textClassName)}>{text}</span>
    </AntdTag>
  );
}
